import React from 'react';

import { ReactComponent as HomeIcon } from 'pages/Teachers/Home/assets/home-icon.svg';

import styles from './styles.module.scss';

const NavTitle = () => (
  <div className={styles.navHeaderGroup}>
    <div className={styles.navTitleRow}>
      <HomeIcon className={styles.homeIcon} />
      <span>Home</span>
    </div>
    <div className={styles.navSubtext}>
      Prioritize grading, review patterns, and plan tomorrow’s next steps.
    </div>
  </div>
);

export default NavTitle;
